import { LightIcon, DarkIcon, SelectedIcon } from "./icons/ApperanceIcon";
import { setTheme } from "redux/actions";
import { useSelector } from "redux/hooks";
import { EThemeType } from "redux/reducers";
import { FormattedMessage } from 'react-intl';
import { useWindowSize } from "hooks/useWindowSize";

interface Props {
    onSelect?: () => void;
}

export const ApperanceSubOptions = ({onSelect}:Props) => {
    const { theme } = useSelector((state) => state.authReducer);
    const currentTheme = useSelector((state) => state.authReducer.theme);
    const {width} = useWindowSize();
    const onUpdateTheme = (theme: EThemeType) => {
        if (theme !== currentTheme) {
            window.postMessage({ theme });
            setTheme(theme);
            if (onSelect) onSelect();
        }
    };
    return (
        <div className={`absolute top-0 flex ml-2 p-[12px] flex-col gap-[6px] rounded-[8px] bg-[white] dark:bg-[#252526] shadow-[0_2px_12px_0_rgba(0,0,0,0.25)] z-10 ${width<850 && width>506 ? "right-full": width<414 ? "left-[58%]": "left-full"} ${width<505 ? "w-[180px]": width<850 ? "w-[248px]": " w-[283px]"}`}  >
            <div className="p-1 hover:bg-[#E5E7EB] dark:hover:bg-[#2A3249] rounded-[4px] flex gap-[8px] items-center cursor-pointer" onClick={() => onUpdateTheme("dark")}>
                <span className="flex-shrink-0 leading-[0]"> <DarkIcon selected={currentTheme === "dark"} /> </span>
                <div className="flex item-center justify-between w-full">
                    <span className={`font-inter text-[14px] leading-normal font-medium ${currentTheme === 'dark'
                        ? theme === 'light'
                            ? 'text-[#4338CA]'
                            : 'text-[#527AE6]'
                        : theme === 'light'
                            ? 'text-[#525252]'
                            : 'text-[#fff]'
                        }`}> <FormattedMessage id="apperacnce.dark.mode" /> </span>
                    {currentTheme === "dark" && (<span className="flex-shrink-0 leading-[0]"> <SelectedIcon theme={theme} /> </span>)}
                </div>
            </div>
            <div className="p-1 hover:bg-[#E5E7EB] dark:hover:bg-[#2A3249] rounded-[4px] flex gap-[8px] items-center cursor-pointer" onClick={() => onUpdateTheme("light")}>
                <span className="flex-shrink-0 leading-[0]"> <LightIcon selected={currentTheme === "light"} /> </span>
                <div className="flex item-center justify-between w-full">
                    <span className={`font-inter text-[14px] leading-normal font-medium ${currentTheme === 'light'
                            ? theme === 'light'
                                ? 'text-[#4338CA]'
                                : 'text-[#527AE6]'
                            : theme === 'light'
                                ? 'text-[#525252]'
                                : 'text-[#fff]'
                        }`}> <FormattedMessage id="apperacnce.light.mode" /> </span>
                    {currentTheme === "light" && (<span className="flex-shrink-0 leading-[0]"> <SelectedIcon theme={theme}/> </span>)}
                </div>
            </div>
        </div >
    );
}